module.exports = __webpack_public_path__ + "img/picc.fb61421a.jpg";